import React from 'react';
import './CatalogueMobileContact.css';

const CatalogueMobileContact = () => {
    return (
        <div className="catalogue-contact-container">
            <div className="catalogue-contact-header">
                <div className="catalogue-contact-image-container">
                    <img src="/images/VRbag01.webp" alt="VR Equipment" className="catalogue-contact-image" />
                </div>
                <div className="catalogue-contact-brand-section">
                    <h1 className="catalogue-contact-title">
                        Engage <span className="catalogue-title-highlight">BUYERS</span> <br />
                        better at <br />
                        <span className="catalogue-title-highlight">PROPERTY Expos</span>
                    </h1>
                </div>
            </div>

            <div className="catalogue-contact-details">
                    <a href="https://maps.app.goo.gl/17sSK3P8sf8KouKp6" target="_blank" rel="noopener noreferrer" className="catalogue-contact-link">
                    <div className="catalogue-contact-item">
                        <div className="catalogue-contact-icon">
                            <i className="fa-solid fa-location-dot"></i>
                        </div>
                        <div className="catalogue-contact-text">
                            <p>Spatial Computing Technologies Pvt.Ltd.</p>
                            <p>VO-550, WeWork Olympia Cyberspace, No 21/22,</p>
                            <p>Alandur Road, Arulayiammanpet, 2nd Street,</p>
                            <p>Guindy, Chennai 600032</p>
                        </div>
                    </div>
                </a>

                <a href="tel:+919769012101" className="catalogue-contact-link">
                    <div className="catalogue-contact-item">
                        <div className="catalogue-contact-icon">
                            <i className="fa-solid fa-phone"></i>
                        </div>
                        <div className="catalogue-contact-text">
                            <p>+91 9769012101</p>
                        </div>
                    </div>
                </a>

                <a href="mailto:info@spatialct.co" className="catalogue-contact-link">
                    <div className="catalogue-contact-item">
                        <div className="catalogue-contact-icon">
                            <i className="fa-solid fa-envelope"></i>
                        </div>
                        <div className="catalogue-contact-text">
                            <p>info@spatialct.co</p>
                        </div>
                    </div>
                </a>

                <a href="https://www.spatialct.co" target="_blank" rel="noopener noreferrer" className="catalogue-contact-link">
                    <div className="catalogue-contact-item">
                        <div className="catalogue-contact-icon">
                            <i className="fa-solid fa-globe"></i>
                        </div>
                        <div className="catalogue-contact-text">
                            <p>www.spatialct.co</p>
                        </div>
                    </div>
                </a>
            </div>

            <div className="catalogue-contact-footer-wave">
                <svg viewBox="0 0 500 150" preserveAspectRatio="none" className="catalogue-wave-svg">
                    <path d="M0,80 C150,150 350,0 500,80 L500,150 L0,150 Z" fill="#e0f2f7"></path>
                </svg>
            </div>
        </div>
    );
};

export default CatalogueMobileContact;
